var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDesktop = function SvgDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "currentColor",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.616 23.603v-1.466h24.769v1.465zm3.126-2.917q-.752 0-1.289-.537a1.76 1.76 0 0 1-.536-1.288V6.178q0-.752.536-1.29a1.76 1.76 0 0 1 1.289-.535h18.516q.752 0 1.289.536t.536 1.289V18.86q0 .752-.536 1.288a1.76 1.76 0 0 1-1.289.537zm0-1.466h18.516q.135 0 .248-.112a.34.34 0 0 0 .111-.247V6.178a.34.34 0 0 0-.111-.248.34.34 0 0 0-.248-.112H4.742a.34.34 0 0 0-.247.112.34.34 0 0 0-.112.248V18.86q0 .135.112.247a.34.34 0 0 0 .247.112"
  })));
};
export default SvgDesktop;